export function throwAsyncError(msg, clientOnly = true) {
  if (clientOnly && process.env.RUN_ENV === 'server') return;

  setTimeout(() => {
    throw new Error(msg);
  });
}
